import React, {useState, useEffect, forwardRef, useImperativeHandle, useRef} from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import {Modal, Pagination, Checkbox, message, Input, Form} from 'antd';
import {deconsent} from '@/api/customer';

const ReasonModal = forwardRef(({reload}, ref) => {
    const formRef = useRef();
    const [visible, setVisible] = useState(false);
    const [externalUserid, setExternalUserid] = useState({});
    const [formData, setFormData] = useState(null);

    useImperativeHandle(ref, () => ({
        open,
    }));

    function open(id) {
        let obj = {externalUserid: id};
        setFormData(obj);
        setTimeout(() => {
            setVisible(true);
        },100)
    }

    function save() {
        formRef.current.submit();
    }

    function onFinish(values) {
        console.log('Received values of form: ', values);
        const {reazon1, reazon2, reazon3, reazon4} = values;
        if (reazon1 && reazon2 && reazon3 && _.isEmpty(reazon4)) {
            message.warn('请填写DeConsent原因！');
            return;
        }
        deconsent(values).then(res => {
            message.success('DeConsent成功');
            setFormData(null);
            setVisible(false);
            reload();
        });
    }

    return (
        <Modal
            title={'DeConsent原因'}
            width={'70%'}
            onCancel={() => setVisible(false)}
            onOk={save}
            visible={visible}
        >
            {formData && (
                <Form ref={formRef} onFinish={onFinish} layout="vertical"
                      initialValues={formData}>
                    <Form.Item hidden name="externalUserid">
                        <Input />
                    </Form.Item>
                    <Form.Item
                        name="reazon1"
                        valuePropName="checked"
                    >
                        <Checkbox>不同意跨境传输</Checkbox>
                    </Form.Item>
                    <Form.Item
                        name="reazon2"
                        valuePropName="checked"
                    >
                        <Checkbox>不同意个人信息采集</Checkbox>
                    </Form.Item>
                    <Form.Item
                        name="reazon3"
                        valuePropName="checked"
                    >
                        <Checkbox>不同意微信会话历史留存</Checkbox>
                    </Form.Item>
                    <Form.Item
                        name="reazon4"
                        label="其他原因"
                        rules={[
                            {
                                required: false,
                                max: 1000,
                            },
                        ]}
                    >
                        <Input placeholder="其他原因" />
                    </Form.Item>
                </Form>
            )}
        </Modal>
    );
});

ReasonModal.propTypes = {
    reload: PropTypes.func,
};

ReasonModal.displayName = 'ReasonModal';

export default ReasonModal;
